function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Form, Input, Button, Select, InputNumber, Modal, Alert } from "antd";
import Common from '../includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var AddOrder = function AddOrder(_ref) {
  var handler = _ref.handler,
    provider = _ref.provider,
    station = _ref.station;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    productsOptions = _useState8[0],
    setProductsOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    productList = _useState0[0],
    setProductList = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    configurationList = _useState10[0],
    setConfigurationList = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    configOptions = _useState12[0],
    setConfigOptions = _useState12[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var saveOrder = function saveOrder(values, up) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('quantity', values.quantity);
    formData.append('gas_station_id', station.id);
    formData.append('provider_id', provider.id);
    formData.append('unit_price', up);
    formData.append('status', 0);
    formData.append('delivered_quantity', 0);
    formData.append('paid_amount', 0);
    formData.append('product_id', values.product_id);
    formData.append('configuration_id', values.configuration_id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addorder', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    var selectedProduct = productList.filter(function (p) {
      return p.id == values.product_id;
    })[0];
    var selectedConfig = configurationList.filter(function (c) {
      return c.id == values.configuration_id;
    })[0];
    var unit_price = selectedProduct.label.slice(3) == 'ESS' ? selectedConfig.petrol_purchase_price : selectedConfig.diesel_purchase_price;
    confirm({
      title: 'Confirmez-vous la création de la commande ?',
      content: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Fournisseur: "
            }), " ", provider.label, " "]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Quantit\xE9: "
            }), " ", values.quantity.toLocaleString('Fr'), " LITRES"]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Produit: "
            }), " ", productsOptions.filter(function (p) {
              return p.value = values.product_id;
            })[0].label, " "]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Prix d'achat par litre: "
            }), unit_price.toLocaleString('Fr'), " GNF"]
          })]
        })
      }),
      onOk: function onOk() {
        saveOrder(values, unit_price);
      }
    });
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + 'getproducts/' + station.id.toString() + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getconfigurations/' + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status != 200 || response[1].data.status != 200) return message.error({
        content: 'Une erreur est survenue pendant le chargement',
        delay: 4
      });
      setProductList(response[0].data.products);
      response[0].data.products.forEach(function (p) {
        if (p.category == 0) setProductsOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            value: p.id,
            label: p.label
          }]);
        });
      });
      setConfigurationList(response[1].data.configurations);
      response[1].data.configurations.forEach(function (c) {
        setConfigOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: "ESS(".concat(c.petrol_user_price.toLocaleString('Fr'), " - ").concat(c.petrol_purchase_price.toLocaleString('Fr'), " GNF)"),
            value: c.id
          }]);
        });
      });
      if (response[1].data.configurations.length > 0 && response[1].data.configurations.filter(function (c) {
        return c.default_selected == 1;
      }).length > 0) form.setFieldsValue({
        configuration_id: response[1].data.configurations.filter(function (c) {
          return c.default_selected == 1;
        })[0].id
      });
      if (response[0].data.products.length > 0) form.setFieldsValue({
        product_id: response[0].data.products.filter(function (p) {
          return p.id == response[0].data.products[0].id && p.category == 0;
        })[0].id
      });
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      style: {
        background: '#FFCE00'
      },
      children: ["Initier une nouvelle commande pour votre station ", /*#__PURE__*/_jsx("b", {
        children: station.label
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "product_id",
        label: "Produit",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: productsOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "configuration_id",
        label: "Schema de prix",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: configOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "quantity",
        label: "Quantit\xE9",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "LITRES",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: productsOptions.length == 0,
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER"
          })
        })
      })]
    })]
  });
};
export default AddOrder;